// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import MintUI from 'mint-ui'
import './assets/reset.css'
import 'amfe-flexible/index'
import 'mint-ui/lib/style.css'
// import VConsole from 'vconsole'
// let vConsole=new VConsole();

var moment = require('moment');

Vue.prototype.$ajax=Axios;
Vue.prototype.$moment=moment;

Vue.config.productionTip = false
Vue.use(MintUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js